import React, { useState, useEffect } from 'react';
import './style.css';

function PAGINACAO({ data, itemsPerPage, renderItems, resetPage }) {
    const [currentPage, setCurrentPage] = useState(1);

    const totalPages = Math.ceil(data.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

    function bMudaPagina(pageNumber) {
        setCurrentPage(pageNumber);
    }

    useEffect(() => {
        if (resetPage) {
            setCurrentPage(1);
        }
    }, [resetPage]);

    return (
        <div>
            <div className="pagination-controls">
                {totalPages < 5
                    ? (Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            className={"page-button" + (currentPage === index + 1 ? " active" : "")}
                            onClick={() => bMudaPagina(index + 1)}
                        >
                            {index + 1}
                        </button>
                    )))
                    : <>
                        <button
                            className="page-button"
                            onClick={() => bMudaPagina(1)}
                            disabled={currentPage === 1}
                        >
                            Primeiro
                        </button>
                        <button
                            className="page-button"
                            onClick={() => bMudaPagina(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            Anterior
                        </button>
                        {/*Array.from({ length: totalPages }, (_, index) => (
                            <button
                                key={index}
                                className={"page-button" + (currentPage === index + 1 ? " active" : "")}
                                onClick={() => bMudaPagina(index + 1)}
                            >
                                {index + 1}
                            </button>
                        ))*/}
                        <button
                            className="page-button"
                            onClick={() => bMudaPagina(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >
                            Próximo
                        </button>
                        <button
                            className="page-button"
                            onClick={() => bMudaPagina(totalPages)}
                            disabled={currentPage === totalPages}
                        >
                            Último
                        </button>
                    </>
                }
            </div>

            {renderItems(currentItems)}


        </div>
    );
}

export default PAGINACAO;